var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDotsThreeOutlineVertical = function SvgIconDotsThreeOutlineVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.125 4.5a2.875 2.875 0 1 1 5.75 0 2.875 2.875 0 0 1-5.75 0M12 3.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75M9.125 12a2.875 2.875 0 1 1 5.75 0 2.875 2.875 0 0 1-5.75 0M12 11.125a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75M12 16.625a2.875 2.875 0 1 0 0 5.75 2.875 2.875 0 0 0 0-5.75m-.875 2.875a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0"
  }))));
};
export default SvgIconDotsThreeOutlineVertical;